
import { useRef } from "react";

/**
 * Hook to manage the cache of fetched account IDs
 */
export const useFollowLinksCache = () => {
  const fetchedAccountsRef = useRef<Set<string>>(new Set());
  
  /**
   * Clear the cache for specific accounts or all accounts
   */
  const clearCache = (accountIdsToReset?: string[]) => {
    if (accountIdsToReset && accountIdsToReset.length > 0) {
      // Remove specific accounts from the fetched set
      accountIdsToReset.forEach(id => {
        fetchedAccountsRef.current.delete(id);
      });
      console.log(`Cleared cache for accounts: ${accountIdsToReset.join(', ')}`);
    } else {
      // Clear all cached accounts
      fetchedAccountsRef.current.clear();
      console.log('Cleared entire follow links cache');
    }
  };
  
  /**
   * Check if an account has been fetched
   */
  const isAccountFetched = (accountId: string): boolean => {
    return fetchedAccountsRef.current.has(accountId);
  };
  
  /**
   * Mark an account as fetched
   */
  const markAccountFetched = (accountId: string): void => {
    fetchedAccountsRef.current.add(accountId);
  };
  
  /**
   * Get accounts that need to be fetched
   */
  const getAccountsToFetch = (accountIds: string[], forceFetch: boolean): string[] => {
    if (forceFetch) return accountIds;
    return accountIds.filter(id => !isAccountFetched(id));
  };
  
  return {
    clearCache,
    isAccountFetched,
    markAccountFetched,
    getAccountsToFetch
  };
};
